import evesBeszamolokTemplate from './eves-beszamolok.pug';

const MODULE_NAME = 'evesBeszamolok';
class EvesBeszamolokController {
	constructor() {
		'ngInject';
	}

	$onInit() {
		this.evesBeszamolokLabel = window.evesBeszamolokLabel;
		this.evesBeszamolok = window.evesBeszamolok;
		this.selectedYear = this.evesBeszamolok[0];
	}
}

export default angular.module(MODULE_NAME, [])
	.component(MODULE_NAME, {
		controller: EvesBeszamolokController,
		template: evesBeszamolokTemplate(),
		bindings: {
		}
	}).name;




// WEBPACK FOOTER //
// ../source/application/eves-beszamolok/eves-beszamolok.js